export const update = {
  updateSuccessfully: 'Update employee successfully!',
}
